<template>
    <div>
        <div v-show="'copytemplate-rule' == currentStep.key" v-if='templateData !== (null || undefined )'>
            <div class="form-group">
                <label for=""> Template Name</label>
                <input type="text" class="form-control" :value="templateData.template_name" disabled>
            </div>
            <div class="form-group">
                <label for=""> Channel</label>
                <input type="text" class="form-control" :value="templateData.channel_name" disabled>
            </div>
            <div class="form-group">
                <label for=""> Category</label>
                <input type="text" class="form-control" :value="templateData.category_name" disabled>
            </div>
            <input type="hidden" name="is_active" value="1">

        </div>
        <div class="active" v-show="'copytemplate-rule' == currentStep.key" v-else>
            <div class="form-group">
                <label for=""> Template Name</label>
                <input type="text" class="form-control" name="template_name" required>
            </div>
            <div class="form-group">
                <label for=""> Channel</label>
                <select class="form-control" name="id_channel" required>
                    <option value="">Select a channel</option>
                    <option v-for="channel in channels" :value="channel.id_channel">{{channel.channel_name}}</option>
                </select>
            </div>
            <div class="form-group">
                <label for=""> Category</label>
                <select class="form-control" name="id_category" required>
                    <option value="">Select a category</option>
                    <option v-for="category in categories" :value="category.id_category">{{category.category_name}}</option>
                </select>
            </div>
            <input type="hidden" name="is_active" value="1">

        </div>
        <div class="active" v-show="'copytemplate-headers' == currentStep.key">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <div class="text-center" v-if="headers.length == 0">Add headers from the list on the right</div>
                        <div class="" v-else>
                            <table class="table table-striped table-lightborder sortable">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Header Name</th>
                                        <th>Header Type</th>
                                        <th>Required</th>
                                        <th>Visible</th>
                                        <th>Duplicatable <br><small>Copy Values</small></th>
                                        <th>Min Words</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for='header in headers' :id="header.id_copy_template_header">
                                        <input type="hidden" v-model="header.weight">

                                        <th class="handle" >
                                            <i class="fa fa-sort"></i>
                                        </th>
                                        <th>{{header.header_name}}</th>
                                        <th>{{header.header_type}}</th>
                                        <th>
                                            <label class="switch">
                                                <input type="checkbox" v-model="header.is_required">
                                                <span class="slider round"></span>
                                            </label>
                                        </th>
                                        <th>
                                            <label class="switch">
                                                <input type="checkbox" v-model="header.is_visible">
                                                <span class="slider round"></span>
                                            </label>
                                        </th>
                                        <th>
                                            <label class="switch">
                                                <input type="checkbox" v-model="header.is_allow_copy_value">
                                                <span class="slider round"></span>
                                            </label>
                                        </th>
                                        <th class="input-search-w">
                                            <input type="text" class="form-control rounded bright" style="width: 80px;text-align: center;font-size: 15px;">
                                        </th>
                                        <th class="">
                                            <span class="btn btn-danger btn-sm" @click="removeHeader(header)">Remove</span>
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="active" v-show="'photodesk-notes' == currentStep.key">
            <div class="form-group">
                <label> Notes</label>
                <textarea class="form-control" rows="3"></textarea>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ['currentStep', 'channels', 'categories', 'headers', 'templateData'],
  data () {
    return {
      user: ''
    }
  },
  mounted () {
    this.getUser()
  },
  updated () {
    this.makeSortable()
  },
  methods: {
    makeSortable () {
      var self = this
      $('.sortable').sortable({
        items: 'tr',
        handle: '.handle',
        cursor: 'move',
        opacity: 0.6,
        stop: function(e, ui) {
            let sort = $('.sortable').sortable('toArray');
            self.updateOrder(sort)

        }
      })
    },
    updateOrder(order) {
      var self = this
      order.forEach(function (key, val) {
        self.headers.forEach(function (header) {
          if (header.id_copy_template_header == parseInt(key)) {
            header.weight = val
          }
        })


      })
    },
    getUser () {
      this.user = this.$store.getters.authUser
    },
    removeHeader (header) {
      this.$emit('headerInterface', header)
    }
  },
  watch: {
    headers () {
      this.makeSortable()
    }
  }
}
</script>

<style scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid #e2e4ee;
  background-color: #fff;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 3px;
  background-color: #e2e4ee;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #a9e474;
}

input:focus + .slider {
  box-shadow: 0 0 1px #a9e474;
}

input:checked + .slider:before {
  background-color: #fff;
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
